import { render, staticRenderFns } from "./HomeProduct.vue?vue&type=template&id=5d39086d&"
import script from "./HomeProduct.vue?vue&type=script&lang=ts&"
export * from "./HomeProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports